import { OrderPrice } from "@raskrask-dk/raskrask-utils";
import {Action} from "../../../action/action";
import type CheckoutState from "../checkoutState";

export const SET_PRICE = "SET_PRICE";
export class SetPrice extends Action<typeof SET_PRICE, OrderPrice> {
  readonly type = SET_PRICE;
  protected state: CheckoutState;

  constructor(state: CheckoutState, priceToPay?: OrderPrice) {
    super(state, priceToPay);
    this.state = state;
  }

  /**
   * Business Logic:
   * This Action is only available if the customer has to pay something.
   * @returns
   */
  public isDoable(): boolean {
    return true;
  }

  public isValid(): boolean {
    return this.isDoable();
  }
}
